import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import BasicUsageReport from "components/Analytics/BasicUsage";
import { basicUsageReport, basicUsageReportData } from "actions/reportsActions";

import { getCompanyId } from "selector/userSelectors";
import actionTypes from "actions/actionTypes";
import withUnmountAction from "enhancers/withUnmountAction";

export const mapStateToProps = state => {
  return {
    data:{},
    records: state.reports.basicUsage
  };
};

export const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      basicUsageReport: basicUsageReport,
      basicUsageReportData: basicUsageReportData
    },
    dispatch
  );
};

const BasicUsageContainer = withUnmountAction({ type: actionTypes.RESET_BASIC_USAGE })
(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(BasicUsageReport)
);

export default BasicUsageContainer;
